import angular from 'angular';
import uiRouter from 'angular-ui-router';
import subcontentComponent from './subcontent.component';

let subcontentModule = angular.module('subcontent', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
  $urlRouterProvider.otherwise('/');
  $stateProvider
    .state('mainmenu.submenu', {
      url: '/:subid',
      component: 'subcontent',
      params: {
        id: null,
        subid: null,
        lang: null,
        p: null
      }
    });
})

.component('subcontent', subcontentComponent)

.name;

export default subcontentModule;



// WEBPACK FOOTER //
// ./client/app/components/home/subcontent/subcontent.js